import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '@web/api/src';
import { Button, useClickOutsideHandler } from '@web/utils';
import { HeaderCartButton } from '@/components/HeaderCartButton';
import { ChoseRetailerButton } from '../ChoseRetailerButton';
import { NavigationLink } from '../NavLink';

const navitems = [
  {
    id: 0,
    link: '/:retailerId/',
    label: 'shop',
  },
  {
    id: 1,
    link: '/:retailerId/documents/farm',
    label: 'farm',
  },
  {
    id: 3,
    link: '/:retailerId/documents/orders',
    label: 'documents',
  },
];

const HeaderNavigation = () => {
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const { logout } = useAuthContext();
  const accountMenuRef = useRef(null);
  useClickOutsideHandler(accountMenuRef, () => setIsAccountMenuOpen(false));

  const handleNavigation = (path) => {
    navigate(path);
    setIsAccountMenuOpen(false);
  };

  return (
    <>
      <nav className="items-center justify-between hidden mx-auto w-full h-8-0 md:flex relative top-0 bg-primary-white container">
        {/* <Logo className="h-4-0" /> */}
        <ChoseRetailerButton />
        <div className="flex gap-4-0 h-full items-center">
          {!isHomePage &&
            navitems.map((item) => (
              <NavigationLink
                key={item.id}
                to={item.link}
                label={item.label}
                end={item.id === 0}
              />
            ))}
          <div className="flex relative items-center" ref={accountMenuRef}>
            <Button
              variant="secondary"
              className="mr-2-0 z-2"
              onClick={() => setIsAccountMenuOpen((prev) => !prev)}
            >
              {t('navigation.account')}
            </Button>
            {isAccountMenuOpen && (
              <div className="absolute z-1 top-[100%] transform -translate-y-0-3 border border-primary-green border-t-0 left-0 bg-primary-white shadow rounded-base">
                <ul className="text-body1 text-primary-green">
                  <li
                    className=" pt-1-5 p-1-0 cursor-pointer hover:bg-primary-green hover:text-primary-white"
                    onClick={() => handleNavigation('/profile')}
                  >
                    {t('global.profile')}
                  </li>
                  <li
                    className=" p-1-0 cursor-pointer hover:bg-primary-green hover:text-primary-white"
                    onClick={() => logout('/login')}
                  >
                    {t('global.logout')}
                  </li>
                </ul>
              </div>
            )}
            <HeaderCartButton />
          </div>
        </div>
      </nav>
    </>
  );
};

export default HeaderNavigation;
